import React from 'react';
import StarBorder from './StarBorder';

const IconMail = () => (
    <svg className="contact-icon__svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
    </svg>
);

const IconLinkedIn = () => (
    <svg className="contact-icon__svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.61 18h-2.77v-5.67c0-1.35-.02-3.09-1.88-3.09-1.89 0-2.18 1.47-2.18 3V21H9.35V9h2.66v1.74h.04c.37-.7 1.26-1.44 2.6-1.44 2.78 0 3.29 1.83 3.29 4.21V21M6.88 7.3a1.6 1.6 0 1 1 .01-3.2A1.6 1.6 0 0 1 6.88 7.3M5.27 21h3.23V9H5.27v12z" />
    </svg>
);

const IconPhone = () => (
    <svg className="contact-icon__svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
);

const Contact = () => {
    return (
        <section id="contact" className="contact-section">
            <div className="lg-glass lg-glass--section">
                <span className="section-heading__accent text-center d-block">Hablemos</span>
                <h2 className="section-heading">Contacto</h2>
                <p className="fs-6 fs-md-5 mb-4 mb-md-5 text-center text-white-50 px-md-4">
                    ¿Tienes una pregunta o propuesta? Me encantaría escucharte. Contáctame a través de estos canales:
                </p>
                <div className="contact-info row g-3 g-md-4 justify-content-center">
                    <div className="col-md-6 col-lg-4">
                        <StarBorder
                            as="div"
                            block
                            className="h-100"
                            innerClassName="contact-card text-center p-4 h-100 lg-glass lg-glass--sm"
                            color="rgba(126, 189, 203, 0.3)"
                            speed="12s"
                        >
                            <div className="contact-icon mb-3" aria-hidden="true">
                                <IconMail />
                            </div>
                            <p className="mb-2 text-white"><strong>Email</strong></p>
                            <a href="mailto:bemendez@alumnos.uai.cl" className="text-decoration-none fw-semibold">bemendez@alumnos.uai.cl</a>
                        </StarBorder>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <StarBorder
                            as="div"
                            block
                            className="h-100"
                            innerClassName="contact-card text-center p-4 h-100 lg-glass lg-glass--sm"
                            color="rgba(126, 189, 203, 0.3)"
                            speed="12s"
                        >
                            <div className="contact-icon mb-3" aria-hidden="true">
                                <IconLinkedIn />
                            </div>
                            <p className="mb-2 text-white"><strong>LinkedIn</strong></p>
                            <a href="https://www.linkedin.com/in/benjamin-mendez-09427a2a4" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-semibold">Ver perfil</a>
                        </StarBorder>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <StarBorder
                            as="div"
                            block
                            className="h-100"
                            innerClassName="contact-card text-center p-4 h-100 lg-glass lg-glass--sm"
                            color="rgba(126, 189, 203, 0.3)"
                            speed="12s"
                        >
                            <div className="contact-icon mb-3" aria-hidden="true">
                                <IconPhone />
                            </div>
                            <p className="mb-2 text-white"><strong>Teléfono</strong></p>
                            <a href="tel:+56957485695" className="text-decoration-none fw-semibold">+56 9 5748 5695</a>
                        </StarBorder>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
